export const painSliderCopyDa = {
    scoringHint:
        "Gå efter dit første indtryk - vælg det tal, der matcher, hvordan du har det lige nu. Du behøver ikke overanalysere det.",
};
